<template>
  <div
    class="rootDiv"
    ref="businesscardContainer"
    v-resize="getBusinessCardWidth"
    :style="`
      margin: ${isInRotator ? '1' : '0'}px;
      height: ${businessCardHeight}px; 
      padding: ${x * 0.04762}px; 
      border-radius: ${businessCardBorderRadius}px;
    `"
  >
    <div class="text-right" :style="`height: ${logoHeight}px;`">
      <!-- <v-img 
        
        :src="logoImageURL"
        
      ></v-img> -->

      <template v-if="$route.name == 'ManageCard' && logoImageURL == ''">
        <v-sheet
          flat
          class="badge-image circle d-inline-flex justify-end align-center"
          :height="logoHeight"
          :width="logoWidth"
        >
          <v-sheet
            :class="[
              'circle d-flex justify-center align-center',
              'dashed-border',
            ]"
            outlined
            :height="logoHeight"
            :width="logoWidth"
          >
            <div class="grey--text text-center logo-text">Add your logo</div>
          </v-sheet>
        </v-sheet>
      </template>
      <div
        v-else
        :class="[logoImageURL == '' ? ['grey', 'lighten-2'] : '']"
        class="d-inline-flex logo-transition logoImage"
        :style="`
          height: ${logoHeight}px; 
          width: ${logoWidth}px;
          border-radius: ${logoFrameBorderRadius}px;
          background-image:url('${logoImageURL}');
          `"
      ></div>
    </div>
    <div
      class="main-text-color font-weight-bold"
      :style="`font-size: ${x * 0.0529}px; line-height: 1.5;`"
    >
      {{ this.title == "" ? "Full Name" : this.title }}
    </div>
    <div
      class="main-text-color font-weight-regular"
      :style="`font-size: ${x * 0.0423}px;line-height: 1.5;`"
    >
      {{ this.subtitle == "" ? "Job Title" : this.subtitle }}
    </div>
    <div
      class="contact-info-list-item font-weight-regular"
      v-if="qualification"
      :style="`font-size: ${x * 0.0423}px;line-height: 1.5;`"
    >
      {{ qualification }}
    </div>

    <div :style="`height: ${x * 0.045}px;`"></div>
    <div
      class="contact-info-list-item"
      :style="`font-size: ${x * 0.0377}px; line-height: 1.6; padding-bottom: ${
        x * 0.015
      }px;`"
    >
      <img
        style="vertical-align: middle"
        class="mr-2"
        src="../assets/phone-logo.png"
        :height="x * 0.045"
        :width="x * 0.045"
      />
      <span>{{ this.line1 == "" ? "+61 123 123 123" : this.line1 }}</span>
    </div>
    <div
      class="contact-info-list-item"
      :style="`font-size: ${x * 0.0377}px; line-height: 1.6; padding-bottom: ${
        x * 0.0155
      }px;`"
    >
      <img
        style="vertical-align: middle"
        class="mr-2"
        src="../assets/email-logo.png"
        :height="x * 0.035"
        :width="x * 0.045"
      />
      <span>{{ this.line2 == "" ? "email@website.com" : this.line2 }}</span>
    </div>
    <div
      class="contact-info-list-item"
      v-if="!qualification"
      :style="`font-size: ${x * 0.0377}px; line-height: 1.6;`"
    >
      <img
        style="vertical-align: middle"
        class="mr-2"
        src="../assets/website-logo.png"
        :height="x * 0.045"
        :width="x * 0.045"
      />
      <span>{{ this.line3 == "" ? "www.website.com" : this.line3 }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "BusinessCardFront",
  computed: {
    ...mapGetters(["userProfile", "businessProfile"]),
    businessCardHeight() {
      return this.x * (250 / 378); //* 0.66;
    },
    businessCardBorderRadius() {
      if (this.cardCorners == "card-corners-curved") return this.x * 0.02646;
      else if (this.cardCorners == "card-corners-square") return 0;
    },
    logoFrameBorderRadius() {
      if (this.logoFrame == "logo-frame-circle") return this.logoHeight / 2;
      else return this.businessCardBorderRadius;
    },
    logoWidth() {
      if (this.logoFrame == "logo-frame-rectangle") return this.x * 0.3;
      return this.x * 0.17;
    },
    logoHeight() {
      return this.x * 0.17;
    },
  },
  props: {
    isInRotator: {
      type: Boolean,
      default: false,
    },
    logoFrame: {
      type: String,
      default: "logo-frame-circle",
    },
    logoImageURL: {
      type: String,
      default: "",
    },
    cardCorners: {
      type: String,
      default: "card-corners-curved",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    line1: {
      type: String,
      default: "",
    },
    line2: {
      type: String,
      default: "",
    },
    line3: {
      type: String,
      default: "",
    },
    qualification: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      x: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getBusinessCardWidth();
    });
    setTimeout(() => {
      this.getBusinessCardWidth();
    }, 1);
    setTimeout(() => {
      if (this.$refs.businesscardContainer != undefined)
        this.$refs.businesscardContainer.classList.add(
          "business-card-border-transition"
        );
    }, 800);
  },
  methods: {
    getBusinessCardWidth() {
      if (this.$refs.businesscardContainer != null)
        this.x = this.$refs.businesscardContainer.clientWidth;
    },
  },
};
</script>
<style scoped>
.rootDiv {
  --webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.business-card-border-transition {
  transition: border-radius 350ms ease-out;
}
.logo-transition {
  transition-duration: 350ms;
  transition-property: height, width, border-radius;
  transition-timing-function: ease-out;
}
.card-corners-curved {
  border-radius: 15px;
}
.card-corners-square {
  border-radius: 2px;
}
.logo-frame-circle {
  border-radius: 50%;
}
.contact-info-list-item {
  color: rgb(81, 96, 119);
}
.main-text-color {
  color: rgb(32, 32, 32);
}
.logoImage {
  /* Full height */
  height: 100%;
  /* Center and scale the image properly */
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
